import { RootState } from "core-integration/src/store";
import { getElementsById } from "core-integration/src/store/elements/reducers";
import { getEntry } from "core-integration/src/store/entries/reducers";
import { getCurrentEvent } from "core-integration/src/store/events/reducers";
import { getPlayerData } from "core-integration/src/store/player/reducers";
import { ellipsis } from "polished";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";

const InfoList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: ${({ theme }) => theme.space[4]};
  padding: 0;
  margin: 0;
`;

const InfoItem = styled.li`
  flex: 1 0 33.3%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 106px;
  padding: 15px 10px 10px 10px;
  border: ${({ theme }) => theme.borders[0]};
  border-radius: ${({ theme }) => theme.radii[2]};
  list-style-type: none;
  background-color: ${({ theme }) => theme.colors.white4};
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints[0]}) {
    flex: 1;
    height: auto;
  }
`;

const ItemHeading = styled.h4`
  margin: 0;
  padding: 0.5rem;
  font-weight: normal;
  white-space: normal;
`;

const ItemValueStat = styled.div`
  ${ellipsis()};
  font-size: 1.8rem;
  padding-bottom: 1.5rem;
  color: ${({ theme }) => theme.colors.white};
`;

const EventInfo = () => {
  const { t } = useTranslation();
  const now = useSelector(getCurrentEvent);
  const elementsById = useSelector(getElementsById);
  const player = useSelector(getPlayerData);
  const entryId = player?.entry ?? 0;
  const entry = useSelector((state: RootState) => getEntry(state, entryId));

  if (!now || !entry) {
    return null;
  }
  const matches = now.chip_plays.filter((cp) => cp.chip_name === "wildcard");
  const wildcards = matches.length ? matches[0].num_played : "-";
  return (
    <div>
      <InfoList>
        {now.id > 1 && (
          <InfoItem>
            <ItemHeading>
              {t("eventInfo.transfersMade", "Transfers Made")}
            </ItemHeading>
            <ItemValueStat>
              {now.transfers_made ? now.transfers_made.toLocaleString() : "-"}
            </ItemValueStat>
          </InfoItem>
        )}
        <InfoItem>
          <ItemHeading>
            {t("eventInfo.wildcardsPlayed", "Wildcards Played")}
          </ItemHeading>
          <ItemValueStat>
            {wildcards === null ? "-" : wildcards.toLocaleString()}
          </ItemValueStat>
        </InfoItem>
        <InfoItem>
          <ItemHeading>
            {t("eventInfo.mostCaptained", "Most Captained")}
          </ItemHeading>
          <ItemValueStat>
            {now.most_captained
              ? elementsById[now.most_captained].web_name
              : "-"}
          </ItemValueStat>
        </InfoItem>
      </InfoList>
    </div>
  );
};

export default EventInfo;
